import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr1004',
    ecrans: ['00-2'],
    params: ['?evrcleintref', '?stamnetab', '?nomprnusu', '?eplnummat', '?caenumdoc', '?caenummat']
});

